import React from 'react'
import { Box } from '@chakra-ui/react'
import { useHistory } from 'react-router-dom'
import groupBy from 'lodash/groupBy'
import { RenderShortcutItem } from './renderShortcutItem'

const DashboardShortcutData = ({ data }) => {
	const history = useHistory()
	const onDashboardClick = ele => {
		history.push(
			`/dashboard/${JSON.stringify({
				value: ele.sub_application_id,
				label: ele.sub_application_name,
				is_card_layout_enabled: !!ele?.is_card_layout_enabled
					? ele?.is_card_layout_enabled
					: 0,
			})}`
		)
	}

	const renderGroupBy = () => {
		const render = []
		const groupByData = groupBy(data, 'group_id')
		if (!!groupByData && Object.keys(groupByData).length > 0) {
			Object.keys(groupByData).forEach(key => {
				const flexItems = groupByData[key].map(item => {
					return (
						<RenderShortcutItem
							item={item}
							onDashboardClick={onDashboardClick}
						/>
					)
				})
				render.push(<Box>{flexItems}</Box>)
			})
		}
		return render
	}

	return (
		<>
			<Box
				w='100%'
				display='grid'
				gridTemplateColumns='0.5fr 1fr 1fr'
				gridColumnGap='1rem'
				alignItems='start'
				style={{ marginBottom: '1rem' }}
				mr='1rem'
			>
				{renderGroupBy()}
			</Box>
		</>
	)
}

export default DashboardShortcutData